import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { mapPedidoFromApi } from "../../../lib/pedidoMapper";

const API = "/api";
const authHeader = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

/**
 * Busca os detalhes completos do pedido via GET /api/pedidos/{id} pra exibir
 * no modal local. Mapeia flat→aninhado (mesmo helper que Pedidos.js usa) pra
 * o componente consumir { cliente.nome, troco.precisa, endereco.endereco }.
 * Retorna { pedido, loading, error }.
 */
export function usePedidoDetail(pedidoId) {
  const [pedido, setPedido] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!pedidoId) {
      setPedido(null);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setError(null);
    axios
      .get(`${API}/pedidos/${pedidoId}`, authHeader())
      .then((r) => {
        if (!cancelled) setPedido(mapPedidoFromApi(r.data));
      })
      .catch((e) => {
        if (cancelled) return;
        const msg = e.response?.data?.detail || "Erro ao carregar pedido";
        setError(msg);
        toast.error(msg);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [pedidoId]);

  return { pedido, loading, error };
}
